export const isValidLat = (coord: number) => coord >= -90 && coord <= 90
export const isValidLng = (coord: number) => coord >= -180 && coord <= 180

// Algolia valid bounds between -180 and 180
export const boundsAlgoliaIsValid = (
  insideBoundingBox: [number, number, number, number],
) => {
  return insideBoundingBox.every((value) => value >= -180 && value <= 180)
}
